up.preview('input-spinner', (preview) => {
    up.util.timer(500, function () {
        if (!preview.ended) {
            let spinnerElement = up.element.createFromHTML('<div class="spinner-border text-danger" role="status"></div>');
            preview.addClass('spinner-wrapper');
            preview.insert(spinnerElement)
        }
    })
});